import React from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";

function Reimagine(props) {
  return (
    <section className="tekgrip_section tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={10} lg={10} xl={10} xxl={10}>
            <div className="example" data-text="Reimagine">
              <h2>Reimagine Digital Healthcare For Modern Needs</h2>
            </div>

            <p className="main_para">
              TekRevol is transforming the healthcare industry with a fresh
              perspective on digital healthcare that prioritizes patient needs,
              leverages cutting-edge technology, and fosters data-driven
              decision-making to improve care quality and operational
              efficiency.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Tab.Container defaultActiveKey="0">
              <Row>
                <Col xs={12} md={6} lg={6} xl={6}>
                  <Nav variant="pills" className="flex-column">
                    <Nav.Item>
                      <Nav.Link eventKey="0">
                        Smart Healthcare Operations
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="1">Critical Data Analysis</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="2">
                        Enhanced Patient Experience
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
                <Col xs={12} md={6} lg={6} xl={6} className="my-auto">
                  <Tab.Content>
                    <Tab.Pane eventKey="0">
                      <p>
                        We believe that digital healthcare should be centered
                        around the patient's needs. That's why we specialize in
                        developing innovative digital health solutions
                        prioritizing patient-centered care, enabling healthcare
                        providers to deliver exceptional experiences and gain a
                        competitive advantage.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="1">
                      <p>
                        We specialize in innovative digital health solutions
                        that leverage advanced data analytics to drive critical
                        insights and improve patient outcomes. Our team of
                        experts combines industry-leading technology with
                        cutting-edge data analysis techniques to help healthcare
                        providers make informed decisions and enhance care
                        quality.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="2">
                      <p>
                        We believe that digital healthcare should be centered
                        around the patient's needs. That's why we specialize in
                        developing innovative digital health solutions
                        prioritizing patient-centered care, enabling healthcare
                        providers to deliver exceptional experiences and gain a
                        competitive advantage.
                      </p>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Reimagine;
